import React from 'react';
import { Button } from "./button.tsx";
import { Loader2 } from "lucide-react";

const WindowsIcon = ({ className = "h-5 w-5" }) => (
  <svg 
    className={className}
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 3.449L9.75 2.1v9.451H0zm10.949-1.285L24 0v11.4H10.949zM0 12.6h9.75v9.451L0 20.699zm10.949.6H24V24l-13.051-1.285z"/>
  </svg>
);

export const ADLoginButton = ({ 
  onClick, 
  isLoading = false, 
  disabled = false, 
  textConfig = {},
  className = ""
}) => {
  return (
    <Button
      variant="outline"
      className={`w-full border-blue-500 text-blue-500 hover:bg-blue-50 hover:text-blue-600 ${className}`}
      type="button"
      onClick={onClick}
      disabled={isLoading || disabled}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          {textConfig.LOGIN_AD_LOADING || "Conectando..."}
        </div>
      ) : (
        <div className="flex items-center justify-center">
          <WindowsIcon className="mr-2 h-5 w-5" />
          {textConfig.LOGIN_AD_BUTTON || "INICIAR SESIÓN POR AD"}
        </div>
      )}
    </Button>
  );
};